import { render, staticRenderFns } from "./MyDealers.vue?vue&type=template&id=a908a96a&"
import script from "./MyDealers.vue?vue&type=script&lang=js&"
export * from "./MyDealers.vue?vue&type=script&lang=js&"
import style0 from "./MyDealers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports